import { STOREMODULE_ENDPOINT_MAP, STOREMODULE_ENDPOINTMODULE_MAP } from '@/assets/js/config/server'

import base from '../base'
import MAINENTITY from '../base/entity-main'
import SEARCH from '../base/entity-search'
import IS from '../base/is'

export default {
    namespaced: true,
    state: base.createState(IS.state, SEARCH.state, MAINENTITY.state, { /* define custom state-properties */ }),
    getters: base.createGetters(IS.getters, SEARCH.getters, MAINENTITY.getters, { /* define custom getters */ }),
    mutations: base.createMutations(IS.mutations, SEARCH.mutations, MAINENTITY.mutations, { /* define custom mutations */ }),
    actions: base.createEntityActions(STOREMODULE_ENDPOINTMODULE_MAP.catalog, STOREMODULE_ENDPOINT_MAP.marketingproducts, IS.actions, SEARCH.actions, MAINENTITY.actions, {/* define custom actions */})
}
